import React from 'react';
import PropTypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { Typography } from '@one-thd/sui-atomic-components';

import { FAQList } from '../subcomponents/FAQ';
import { FAQSkeleton } from '../subcomponents/Skeletons';

import { emtContentDataModel } from '../dataModels';
import { PAGE_NAMES } from '../../constants';

const StoreDetailsFAQ = ({ storeId }) => {
  const { data, loading, error } = useDataModel('emtContent', {
    variables: {
      pageName: PAGE_NAMES.DETAILS,
      contentId: storeId,
    }
  });

  if (loading) return <FAQSkeleton />;

  const storeDetailsResponse = data?.emtContent?.content?.storeDetails;
  const isArray = Array.isArray(storeDetailsResponse);
  const faqs = isArray ? storeDetailsResponse?.[1]?.faq : storeDetailsResponse?.faq;
  const faqTitle = isArray ? storeDetailsResponse?.[1]?.faqHeader : storeDetailsResponse?.faqHeader;

  if (!data || !storeDetailsResponse || !faqs?.length || error) return null;

  return (
    <div className="sui-bg-primary sui-p-4 sui-flex sui-flex-col sui-gap-4">
      {faqTitle && <Typography variant="h2">{faqTitle}</Typography>}
      <div className="sui-flex sui-flex-col sui-gap-4">
        <FAQList faqs={faqs} />
      </div>
    </div>
  );
};

StoreDetailsFAQ.propTypes = {
  storeId: PropTypes.string.isRequired
};

StoreDetailsFAQ.displayName = 'StoreDetailsFAQ';
StoreDetailsFAQ.dataModel = emtContentDataModel;

export default StoreDetailsFAQ;